import React from 'react';
import IconButton from '@mui/material/IconButton';
import SaveIcon from '@mui/icons-material/Save';

interface Props {
  onExecute: () => void;
}

function CommitButton({ onExecute }: Props) {
  return (
    <IconButton onClick={onExecute} title="Änderungen speichern">
      <SaveIcon />
    </IconButton>
  );
}

export default CommitButton;
